import { render } from "./GenerateApprovalRefundDialog.vue?vue&type=template&id=c53ade20&scoped=true"
import script from "./GenerateApprovalRefundDialog.vue?vue&type=script&lang=ts"
export * from "./GenerateApprovalRefundDialog.vue?vue&type=script&lang=ts"

import "./GenerateApprovalRefundDialog.vue?vue&type=style&index=0&id=c53ade20&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c53ade20"

export default script